import { render, staticRenderFns } from "./cartPopupCounter.vue?vue&type=template&id=2061e3f4&scoped=true&"
import script from "./cartPopupCounter.vue?vue&type=script&lang=js&"
export * from "./cartPopupCounter.vue?vue&type=script&lang=js&"
import style0 from "./cartPopupCounter.vue?vue&type=style&index=0&id=2061e3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061e3f4",
  null
  
)

export default component.exports